import { KnownInstrumentationEvents } from '@office-start/instrumentation-types';
import { logFeature, logImpression, logUserAction, } from '@office-start/telemetry-service';
export var Area = 'TuiCallout';
var IdPrefix = 'tui';
var TuiFeatureCalloutIdParam = 'CalloutId';
var TuiFeatureSequenceIdParam = 'SequenceId';
var TuiFeatureDismissTypeParam = 'DismissType';
export function logTuiFeature(eventName, additionalParams) {
    var currentStep = additionalParams.currentStep, subArea = additionalParams.subArea, dismissType = additionalParams.dismissType;
    var _a = currentStep !== null && currentStep !== void 0 ? currentStep : {}, calloutId = _a.id, sequenceId = _a.sequenceId;
    var params = {};
    if (calloutId) {
        params[TuiFeatureCalloutIdParam] = calloutId;
    }
    if (sequenceId) {
        params[TuiFeatureSequenceIdParam] = sequenceId;
    }
    if (dismissType) {
        params[TuiFeatureDismissTypeParam] = dismissType;
    }
    logFeature({
        featureName: "TeachingUi" /* KnownFeatureNames.TeachingUi */,
        eventName: eventName,
        params: params,
        area: Area,
        subArea: subArea,
    });
}
export function logTuiImpression(eventName) {
    logImpression({
        eventName: eventName,
        area: Area,
    });
}
export function logTuiComplete(dismissType, currentStep) {
    var _a = dismissType === 'completed'
        ? {
            eventName: KnownInstrumentationEvents.TuiCompleted,
            subArea: 'TuiDoneButton',
        }
        : dismissType === 'closed'
            ? {
                eventName: KnownInstrumentationEvents.TuiDismissed,
                subArea: 'TuiCloseButton',
            }
            : {
                eventName: KnownInstrumentationEvents.TuiDismissed,
            }, subArea = _a.subArea, eventName = _a.eventName;
    logTuiAction(dismissType, eventName, 'Close', subArea);
    logTuiFeature(eventName, {
        subArea: subArea,
        currentStep: currentStep,
        dismissType: dismissType !== 'completed' ? dismissType : undefined,
    });
}
export function logTuiAction(actionId, eventName, result, subArea) {
    var actionProperties = {
        id: "".concat(IdPrefix, "-").concat(actionId),
        eventName: eventName,
        area: Area,
        subArea: subArea,
        result: result,
        target: 'TuiCallout',
    };
    logUserAction(actionProperties);
}
//# sourceMappingURL=tuiInstrumentation.js.map